/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type shifts_ShiftWarningResponse = {
    /**
     * DAY_TOO_LONG, WEEK_TOO_LONG or REST_TOO_SHORT
     */
    code: shifts_ShiftWarningResponse.code;
    /**
     * The day concerned (YYYY-MM-DD): the shift's day, the Monday of the week, or the later of the two working days for the rest time
     */
    date: string;
    /**
     * The limit in minutes: the day limit, the contract hours plus the allowed excess, or the minimum rest
     */
    limit_minutes: number;
    /**
     * Computed net minutes of the day or week, or the minutes of rest
     */
    value_minutes: number;
};
export namespace shifts_ShiftWarningResponse {
    /**
     * DAY_TOO_LONG, WEEK_TOO_LONG or REST_TOO_SHORT
     */
    export enum code {
        DAY_TOO_LONG = 'DAY_TOO_LONG',
        WEEK_TOO_LONG = 'WEEK_TOO_LONG',
        REST_TOO_SHORT = 'REST_TOO_SHORT',
    }
}

